import { MultiInput } from "@joonapp/web-shared"
import { forwardRef } from "react"

export interface PasscodeInputRef {
  focusFirstInput: (delay?: number) => void
  clearInputs: () => void
}

const PasscodeInput = forwardRef<
  PasscodeInputRef,
  {
    value: string
    setValue: (value: string) => void
  }
>(({ value, setValue }, ref) => {
  return (
    <MultiInput
      name="passcode"
      value={value}
      setValue={setValue}
      containerStyle={{ width: "100%" }}
      inputStyle={{ width: "100%", height: "48px" }}
      gap={4}
      ref={ref}
    />
  )
})

PasscodeInput.displayName = "PasscodeInput"

export default PasscodeInput
